import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    getWebhookDeliveryDetailFetchSuccess,
    getWebhookDeliveryDetailFetchFailure,
} from './reducer';
import { WebhookDeliveryDetailResType } from 'src/types/webhookDeliveryDetail';

const getWebhookDeliveryDetailFetchRequest = async (eventId: string) => {
    const res = await api('get', `api/secure/webhooks/deliveries/${eventId}`);
    return res.data;
};

function* getWebhookDeliveryDetailFetch(action: { type: string; payload: string }) {
    try {
        const response: WebhookDeliveryDetailResType = yield call((): any =>
            getWebhookDeliveryDetailFetchRequest(action.payload)
        );
        yield put(getWebhookDeliveryDetailFetchSuccess(response));
    } catch (error) {
        yield put(getWebhookDeliveryDetailFetchFailure());
    }
}

export function* getWebhookDeliveryDetailFetchWatch() {
    yield takeEvery('webhookDeliveryDetail/getWebhookDeliveryDetailFetch', getWebhookDeliveryDetailFetch);
}
